import type { MetaFile } from "../base/MetaFile"
import type { VirtualFileType } from "../VirtualFileType"
import type { GeneratedFile } from "./GeneratedFile"
import type { RemoteFile } from "./RemoteFile"
import type { SinglePagePdf } from "./SinglePagePdf"

export type MultiPagePdf = {
  readonly enum: VirtualFileType.MULTI_PAGE_PDF
  readonly content: GeneratedFile | RemoteFile
  readonly pages: SinglePagePdf[]
} & MetaFile
